/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { BranchBankPaginationResponseDto } from '../model/branchBankPaginationResponseDto';
import { BranchBankRequestDto } from '../model/branchBankRequestDto';
import { BranchBankResponseDto } from '../model/branchBankResponseDto';
import { BranchDocumentPaginationResponseDto } from '../model/branchDocumentPaginationResponseDto';
import { BranchDocumentRequestDto } from '../model/branchDocumentRequestDto';
import { BranchDocumentResponseDto } from '../model/branchDocumentResponseDto';
import { BranchDropdownResponseDto } from '../model/branchDropdownResponseDto';
import { BranchPaginationResponseDto } from '../model/branchPaginationResponseDto';
import { BranchPhonePaginationResponseDto } from '../model/branchPhonePaginationResponseDto';
import { BranchPhoneRequestDto } from '../model/branchPhoneRequestDto';
import { BranchPhoneResponseDto } from '../model/branchPhoneResponseDto';
import { BranchRenewalHistoryResponseDto } from '../model/branchRenewalHistoryResponseDto';
import { BranchRenewalRequestDto } from '../model/branchRenewalRequestDto';
import { BranchRequestDto } from '../model/branchRequestDto';
import { BranchResponseDto } from '../model/branchResponseDto';
import { ValidationError } from '../model/validationError';

export enum branchesBankGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum branchesDropdownGetTypeEnum {
  franchise = 'franchise',
  wpn = 'wpn',
}
export enum branchesDropdownGetBranchExpirationStatusEnum {
  active = 'active',
  expiring_soon = 'expiring_soon',
  expired = 'expired',
}
export enum branchesGetTypeEnum {
  franchise = 'franchise',
  wpn = 'wpn',
}
export enum branchesGetBranchExpirationStatusEnum {
  active = 'active',
  expiring_soon = 'expiring_soon',
  expired = 'expired',
}
export enum branchesPhoneGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum branchesRenewalNearlyOrExpiredGetTypeEnum {
  franchise = 'franchise',
  wpn = 'wpn',
}
export enum branchesRenewalNearlyOrExpiredGetBranchExpirationStatusEnum {
  active = 'active',
  expiring_soon = 'expiring_soon',
  expired = 'expired',
}
export enum branchesRenewalNearlyOrExpiredGetStatusEnum {
  pending = 'pending',
  in_progress = 'in_progress',
  completed = 'completed',
}

@Injectable({
  providedIn: 'root',
})
export class BranchesService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public branchesBankGet$(page?: number, limit?: number, branchId?: string, language?: string): Observable<BranchBankPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branches/bank`, { page, limit, branchId, language });
  }
  /**
   * [Authorize] type: http
   */
  public branchesBankIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/branches/bank/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesBankIdPut$(id: string, body: BranchBankRequestDto): Observable<BranchBankResponseDto> {
    return this.api.put(`${apiBaseUrl()}/branches/bank/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesBankPost$(body: BranchBankRequestDto): Observable<BranchBankResponseDto> {
    return this.api.post(`${apiBaseUrl()}/branches/bank`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesDocumentGet$(page?: number, limit?: number, branchId?: string): Observable<BranchDocumentPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branches/document`, { page, limit, branchId });
  }
  /**
   * [Authorize] type: http
   */
  public branchesDocumentIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/branches/document/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesDocumentIdPut$(id: string, body: BranchDocumentRequestDto): Observable<BranchDocumentResponseDto> {
    return this.api.put(`${apiBaseUrl()}/branches/document/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesDocumentPost$(body: BranchDocumentRequestDto): Observable<BranchDocumentResponseDto> {
    return this.api.post(`${apiBaseUrl()}/branches/document`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesDropdownGet$(page?: number, limit?: number, franchiseTierId?: string, type?: string, beginRegisterDate?: string, endRegisterDate?: string, name?: string, branchName?: string, provinceCode?: string, beginContractStartDate?: string, endContractStartDate?: string, beginContractEndDate?: string, endContractEndDate?: string, isActive?: boolean, branchExpirationStatus?: string, sort?: string): Observable<Array<BranchDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/branches/dropdown`, { page, limit, franchiseTierId, type, beginRegisterDate, endRegisterDate, name, branchName, provinceCode, beginContractStartDate, endContractStartDate, beginContractEndDate, endContractEndDate, isActive, branchExpirationStatus, sort });
  }
  /**
   * [Authorize] type: http
   */
  public branchesGet$(page?: number, limit?: number, franchiseTierId?: string, type?: string, beginRegisterDate?: string, endRegisterDate?: string, name?: string, branchName?: string, provinceCode?: string, beginContractStartDate?: string, endContractStartDate?: string, beginContractEndDate?: string, endContractEndDate?: string, isActive?: boolean, branchExpirationStatus?: string, sort?: string): Observable<BranchPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branches`, { page, limit, franchiseTierId, type, beginRegisterDate, endRegisterDate, name, branchName, provinceCode, beginContractStartDate, endContractStartDate, beginContractEndDate, endContractEndDate, isActive, branchExpirationStatus, sort });
  }
  /**
   * [Authorize] type: http
   */
  public branchesIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/branches/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesIdGet$(id: string): Observable<BranchResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branches/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesIdPut$(id: string, body: BranchRequestDto): Observable<BranchResponseDto> {
    return this.api.put(`${apiBaseUrl()}/branches/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/branches/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesPhoneGet$(page?: number, limit?: number, branchId?: string, language?: string): Observable<BranchPhonePaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branches/phone`, { page, limit, branchId, language });
  }
  /**
   * [Authorize] type: http
   */
  public branchesPhoneIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/branches/phone/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesPhoneIdPut$(id: string, body: BranchPhoneRequestDto): Observable<BranchPhoneResponseDto> {
    return this.api.put(`${apiBaseUrl()}/branches/phone/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesPhonePost$(body: BranchPhoneRequestDto): Observable<BranchPhoneResponseDto> {
    return this.api.post(`${apiBaseUrl()}/branches/phone`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesPost$(body: BranchRequestDto): Observable<BranchResponseDto> {
    return this.api.post(`${apiBaseUrl()}/branches`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesRenewalHistoryBranchIdGet$(branchId: string): Observable<Array<BranchRenewalHistoryResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/branches/renewal/history/${encodeURIComponent(String(branchId))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchesRenewalNearlyOrExpiredGet$(page?: number, limit?: number, franchiseTierId?: string, type?: string, beginRegisterDate?: string, endRegisterDate?: string, name?: string, branchName?: string, provinceCode?: string, beginContractStartDate?: string, endContractStartDate?: string, beginContractEndDate?: string, endContractEndDate?: string, isActive?: boolean, branchExpirationStatus?: string, status?: string, sort?: string): Observable<BranchPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branches/renewal/nearly-or-expired`, { page, limit, franchiseTierId, type, beginRegisterDate, endRegisterDate, name, branchName, provinceCode, beginContractStartDate, endContractStartDate, beginContractEndDate, endContractEndDate, isActive, branchExpirationStatus, status, sort });
  }
  /**
   * [Authorize] type: http
   */
  public branchesRenewalRenewBranchIdPut$(branchId: string, body: BranchRenewalRequestDto): Observable<BranchRenewalHistoryResponseDto> {
    return this.api.put(`${apiBaseUrl()}/branches/renewal/renew/${encodeURIComponent(String(branchId))}`, body, undefined);
  }
}
